var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg52Star(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.93,
    height: 57.933,
    viewBox: "0 0 57.93 57.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_62bc672ce0fa1d23adf660f4_check-green-icon",
    "data-name": "62bc672ce0fa1d23adf660f4_check-green-icon",
    d: "M43.6,2.917l.338.672,2.528,6.729a1.955,1.955,0,0,0,1.146,1.146l6.5,2.44a5.877,5.877,0,0,1,3.626,7l-.184.571-3.02,6.685a1.958,1.958,0,0,0,0,1.624L57.4,36.1a5.881,5.881,0,0,1-2.388,7.506l-.672.338-6.729,2.528a1.963,1.963,0,0,0-1.141,1.146l-2.44,6.5a5.882,5.882,0,0,1-7,3.626l-.571-.184-6.685-3.02a1.958,1.958,0,0,0-1.624,0l-6.316,2.871a5.882,5.882,0,0,1-7.506-2.388l-.338-.671L11.46,47.618a1.962,1.962,0,0,0-1.146-1.141l-6.5-2.44a5.882,5.882,0,0,1-3.626-7l.184-.571L3.4,29.78a1.962,1.962,0,0,0,0-1.624L.526,21.84A5.882,5.882,0,0,1,2.91,14.334L3.581,14l6.733-2.537a1.962,1.962,0,0,0,1.146-1.146l2.44-6.5a5.882,5.882,0,0,1,7-3.626l.571.184L28.153,3.4a1.962,1.962,0,0,0,1.624,0L36.1.53A5.882,5.882,0,0,1,43.6,2.913Z",
    fill: "#ffb164"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52Star);
export default __webpack_public_path__ + "static/media/5.2_Star.5e60e0120c9dfa3ebf0332521cb2199d.svg";
export { ForwardRef as ReactComponent };